import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sokusai-management-unblock',
  templateUrl: './sokusai-management-unblock.component.html',
  styleUrls: ['./sokusai-management-unblock.component.css', '../style/global.css'],
})
export class SokusaiManagementUnblockComponent implements OnInit {
  countdown = 10;
  initialize = false;
  @Input()
  clientId: string;
  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.initialize = true;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.redirect();
          clearInterval(interval);
        }
      }, 1000);
    }, 1000);
  }

  redirect() {
    location.href = environment.apps[this.clientId].appUrl;
  }

  get logoUrl() {
    return (
      environment.apps[this.clientId].oemConfig?.imgpath ||
      '/assets/wellnesscloud/images/logo.svg'
    );
  }

  get appname() {
    return 'ウェルネスクラウド';
  }
}
